<template>
  <div class="image-detail-wrapper">
    <div class="container">
      <div>
        <button class="button-secondary my-10" @click="$router.back()">
          <span>Back</span>
        </button>
      </div>
      <div class="image-container">
        <div class="card w-100 h-100">
          <div class="image-content">
            <div class="image-view-container">
              <img v-if="imageUrl" :src="imageUrl" class="image-preview"/>
            </div>
            <div class="image-detail-container" v-if="image && album">
              <h2 v-if="!isEditing" class="title">{{ image.image_name }}</h2>
              <input type="text" v-if="isEditing" class="input" id="title-input" v-model="editedImage.name">
              <p class="subtitle">in album: {{ album.album_name }}</p>

              <p v-if="!isEditing">{{ image.description }}</p>
              <textarea v-if="isEditing" class="input" id="description-input" rows="10"
                        v-model="editedImage.description">
              </textarea>
              <div v-if="!isEditing" class="publish-state">
                <svg v-if="image.published" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                     fill="currentColor"
                     class="bi bi-eye-fill" viewBox="0 0 16 16">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                </svg>
                <svg v-if="!image.published" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                     fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                  <path
                      d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
                  <path
                      d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
                </svg>
                <p>{{ image.published ? 'Published' : 'Private' }}</p>
              </div>
              <div v-if="isEditing" class="edit-publish-state-container">
                <svg id="edit-set-public-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="auto"
                     fill="currentColor"
                     class="bi bi-eye-fill selectable" viewBox="0 0 16 16"
                     :class="editedImage.publish ? 'public-state-selected' : 'public-state-unselected'"
                     @click="setPublic">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                </svg>
                <svg id="edit-set-private-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="auto"
                     fill="currentColor" class="bi bi-eye-slash-fill selectable" viewBox="0 0 16 16"
                     :class="editedImage.publish ? 'public-state-unselected' : 'public-state-selected'"
                     @click="setPrivate">
                  <path
                      d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
                  <path
                      d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
                </svg>
                <p>{{ editedImage.publish ? 'Published' : 'Private' }}</p>

              </div>
              <div v-if="!isEditing" class="image-likes-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
                  <path
                      d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
                </svg>
                <p>{{ numberOfLikes }}</p>
              </div>
              <div v-if="!isEditing" class="like-action-container">
                <svg id="like-image-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     class="bi bi-hand-thumbs-up-fill selectable" viewBox="0 0 16 16"
                     :class="hasLikedImage ? 'image-liked' : 'image-not-liked'"
                     @click="toggleLike">
                  <path
                      d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
                </svg>
                <p v-if="hasLikedImage">
                  You liked this image
                </p>
                <p v-else>Like this image</p>
              </div>
              <div v-if="isImageOwner" class="actions-container">
                <svg v-if="!isEditing" id="edit-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="auto"
                     fill="currentColor"
                     class="bi bi-pencil-fill selectable" viewBox="0 0 16 16" @click="startEditing">
                  <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                </svg>
                <svg v-if="!isEditing" id="delete-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="auto"
                     fill="currentColor"
                     class="bi bi-trash-fill selectable" viewBox="0 0 16 16" @click="deleteImage">
                  <path
                      d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"/>
                </svg>
                <svg v-if="isEditing" id="save-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="auto"
                     fill="currentColor"
                     class="bi bi-check-lg selectable" viewBox="0 0 16 16" @click="updateImage">
                  <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                </svg>
                <svg v-if="isEditing" id="cancel-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="auto"
                     fill="currentColor" class="bi bi-x-lg selectable"
                     viewBox="0 0 16 16" @click="stopEditing">
                  <path
                      d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import apiService from '@/services/apiService';
import {onMounted, reactive, ref} from 'vue'
import router from "@/router";

const {image_id} = defineProps({
  image_id: String
})

const isImageOwner = ref(false);
const imageUrl = ref(null);
const image = ref(null);
const album = ref(null);
const numberOfLikes = ref(0);
const hasLikedImage = ref(false);

const isEditing = ref(false);

const editedImage = reactive({
  name: '',
  description: '',
  publish: false
})

onMounted(async () => {
  window.addEventListener('keydown', handleKeyEventDown);

  await getImageUrl();
  await loadImage();
  await getNumberOfLikes();
  await checkIfUserHasLiked();
  setImageOwner();
})

async function loadImage() {
  image.value = await apiService.getImage(image_id);
  album.value = await apiService.getAlbumById(image.value.album_id)
}

async function getImageUrl() {
  const response = await apiService.getImageSignedUrl(image_id);
  imageUrl.value = response.url;
}

async function getNumberOfLikes() {
  const response = await apiService.getNumberOfLikes(image_id);
  numberOfLikes.value = response.likes;
}

async function checkIfUserHasLiked() {
  const response = await apiService.getImageLikeStatus(image_id);
  hasLikedImage.value = response.liked;
}

function setImageOwner() {
  isImageOwner.value = image.value.user_id === localStorage.getItem('userId');
}

function startEditing() {
  editedImage.name = image.value.image_name;
  editedImage.description = image.value.description;
  editedImage.publish = image.value.published;
  isEditing.value = true;
}

function stopEditing() {
  isEditing.value = false;
}

function setPublic() {
  editedImage.publish = true;
}

function setPrivate() {
  editedImage.publish = false;
}

async function updateImage() {
  await apiService.updateImage(image_id, editedImage);
  stopEditing();
  await loadImage();
}

async function deleteImage() {
  await apiService.deleteImage(image_id);
  await navigateToAlbum();
}

async function toggleLike() {
  if (hasLikedImage.value) {
    await unlikeImage();
  } else {
    await likeImage();
  }
  await getNumberOfLikes();
  await checkIfUserHasLiked();
}

async function likeImage() {
  await apiService.addLikeToImage(image_id);
}

async function unlikeImage() {
  await apiService.removeLikeFromImage(image_id);
}

async function navigateToAlbum() {
  await router.push(`/albums/${album_id}`)
}

function handleKeyEventDown(event) {
  if (event.key === 'Escape') {
    stopEditing();
  }
}
</script>

<style scoped>
.image-detail-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
  height: 100%;
}

.image-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;
}

.image-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  height: fit-content;
}

.image-view-container {
  width: 65%;
  height: 100%;
}

.image-detail-container {
  width: 35%;
  height: 100%;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}

.image-preview {
  max-height: 100%;
  max-width: 100%;
  border-radius: 5px;
}

.title {
  margin-bottom: 0.5rem;
  font-size: 2rem;
}

.subtitle {
  color: gray;
  font-size: 1rem;
  margin: 0 0;
}

.publish-state {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.image-likes-container {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-bottom: 1rem;
}

.image-likes-container p {
  margin: 0;
}

.like-action-container {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.4rem;
  font-size: 0.8rem;
}

.actions-container {
  justify-self: end;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1rem;
  border-top: 1px solid lightgray;
  padding-top: 0.5rem;
  width: 100%;
}

#edit-icon, #delete-icon, #save-icon, #cancel-icon {
  fill: darkgray;
  transition: fill 0.2s ease-in-out;
}

#edit-icon:hover {
  fill: #1a3968;
}

#delete-icon:hover {
  fill: lightcoral;
}

#title-input {
  font-size: 1.5rem;
  font-weight: bold;
  width: 90%;
}

#save-icon:hover {
  fill: #2E7D32;
}

#cancel-icon:hover {
  fill: lightcoral;
}

#description-input {
  width: 90%;
  margin-top: 1rem;
}

#edit-set-public-icon, #edit-set-private-icon {
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 0.5rem;
}

.edit-publish-state-container {
  display: flex;
  align-items: center;
  gap: 0.4rem
}

.public-state-unselected {
  fill: lightgray;
}

.public-state-selected {
  background-color: #f1f1f1;
}

#like-image-icon {
  background-color: #ededed;
  padding: 0.3rem;
  border-radius: 5px;
}

.image-liked {
  fill: #1e4482;
}

.image-not-liked {
  fill: darkgray;
}
</style>